export default "__VITE_ASSET__cb7d8e4f__"